import { render, staticRenderFns } from "./FootInfo.vue?vue&type=template&id=4e0eb019"
import script from "./FootInfo.vue?vue&type=script&lang=js"
export * from "./FootInfo.vue?vue&type=script&lang=js"
import style0 from "./FootInfo.vue?vue&type=style&index=0&id=4e0eb019&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports